import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Services
export const getServices = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.search) params.append('search', filters.search);
  if (filters.service_type) params.append('service_type', filters.service_type);
  if (filters.state) params.append('state', filters.state);
  if (filters.city) params.append('city', filters.city);
  if (filters.cost) params.append('cost', filters.cost);
  if (filters.mode) params.append('mode', filters.mode);
  
  const response = await axios.get(`${API}/services?${params.toString()}`);
  return response.data;
};

export const getService = async (id) => {
  const response = await axios.get(`${API}/services/${id}`);
  return response.data;
};

export const getMyServices = async () => {
  const response = await axios.get(`${API}/services/my/all`);
  return response.data;
};

export const createService = async (serviceData) => {
  const response = await axios.post(`${API}/services`, serviceData);
  return response.data;
};

export const updateService = async (id, serviceData) => {
  const response = await axios.put(`${API}/services/${id}`, serviceData);
  return response.data;
};

// Admin
export const getPendingServices = async () => {
  const response = await axios.get(`${API}/admin/services/pending`);
  return response.data;
};

export const getAllServicesAdmin = async () => {
  const response = await axios.get(`${API}/admin/services/all`);
  return response.data;
};

export const approveService = async (id, action, reason = null) => {
  const response = await axios.post(`${API}/admin/services/${id}/approve`, {
    action,
    reason,
  });
  return response.data;
};

// Emergency Resources
export const getEmergencyResources = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.scope) params.append('scope', filters.scope);
  if (filters.state) params.append('state', filters.state);
  
  const response = await axios.get(`${API}/emergency?${params.toString()}`);
  return response.data;
};

export const createEmergencyResource = async (resourceData) => {
  const response = await axios.post(`${API}/admin/emergency`, resourceData);
  return response.data;
};

export const updateEmergencyResource = async (id, resourceData) => {
  const response = await axios.put(`${API}/admin/emergency/${id}`, resourceData);
  return response.data;
};

export const deleteEmergencyResource = async (id) => {
  const response = await axios.delete(`${API}/admin/emergency/${id}`);
  return response.data;
};
